import { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { useIsMobile } from '../hooks/useMediaQuery';

/**
 * Offline Indicator — shows a banner when the user loses internet connection.
 * Only visible on mobile for a cleaner desktop experience.
 */
export default function OfflineIndicator() {
  const isMobile = useIsMobile();
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline || !isMobile) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-rose-500 text-white text-center py-2 px-4 text-xs font-bold flex items-center justify-center gap-2 safe-top">
      <WifiOff className="w-4 h-4" />
      <span>You're offline — changes won't be saved</span>
    </div>
  );
}
